@if (!filesUploaded) {
  <div ngfDrop
       [selectable]="true"
       [multiple]="multiple"
       [accept]="accept"
       [maxSize]="maxFileSize"
       [ngfFixOrientation]="false"
       [(validDrag)]="dropValid"
       [(invalidDrag)]="dropInvalid"
       (filesChange)="onFilesChange($event)"
       [ngClass]="[dropValid ? 'border-width-2 border-success' : dropInvalid ? 'border-width-2 border-danger' : 'border-secondary']"
       class="p-1 rounded border border-dashed">
    <span class="btn btn-primary">{{ buttonText | messageTranslate }}</span>
    <span class="ms-3">{{ dropText | messageTranslate }}</span>
  </div>
} @else {
  <button type="button" class="btn btn-secondary" (click)="onFilesChange()">{{ clearButtonText | messageTranslate }}</button>
}
